import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/Logo";
import { LangToggle } from "@/components/LangToggle";

export default function ForgotPassword() {
  const { t } = useApp();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setSent(true); setLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="flex items-center justify-between px-6 pt-6">
        <Link to="/login" className="eyebrow hover:text-[color:var(--cu-gold-light)]">← {t("back_to_sign_in")}</Link>
        <LangToggle />
      </header>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-sm fade-up">
          <Logo size="md" />
          <h1 className="font-serif-cu text-2xl text-center mt-10 mb-8">{t("reset_password")}</h1>
          {sent ? (
            <p data-testid="forgot-sent" className="text-sm text-[color:var(--cu-muted)] text-center leading-relaxed">{t("reset_sent")}</p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="eyebrow block mb-2">{t("email")}</label>
                <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="cu-input w-full px-4 py-3 text-sm" />
              </div>
              <button data-testid="forgot-submit-button" disabled={loading} className="btn-gold w-full py-3.5 text-sm">{t("send_reset_link")}</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
